import { Share2 } from "lucide-react";
import { cn } from "~/lib/utils";

interface SocialShareProps {
  url: string;
  title: string;
  description: string;
  className?: string;
}

export function SocialShare({ url, title, description, className }: SocialShareProps) {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text: description,
          url,
        })
      } catch (error) {
        console.log('Error sharing:', error)
      }
    } else {
        // Fallback
        console.log('Web Share API not supported')
    }
  }

  return (
    <button
        onClick={handleShare} 
        className={cn("inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors", className)}
    >
      <Share2 className="h-4 w-4" />
      <span className="text-xs font-medium uppercase tracking-wider">Share</span>
    </button>
  );
}

